import alt from "../alt";

import UserStore from "./UserStore";

import GodActions from "../actions/GodActions";
import GodUtil from "../utils/GodUtil";
import EventBucketActions from "../actions/EventBucketActions";
import UserActions from "../actions/UserActions";

import { history } from "../util";

class GodStore {
  constructor() {
    this.bindActions(GodActions);

    this.state = {
      autoCreating: false,
      stats: null,
      revenue: null,
      upcomingEvents: null
    };
  }

  onCreateFakeEventBucket(options) {
    GodUtil.createFakeEventBucket(UserStore.getState().apiKey, options)
      .then(data => {
        EventBucketActions.fetchAll.defer();
      })
      .catch(GodActions.godFailed);
  }

  onAutoCreate(options) {
    this.setState({ autoCreating: true });

    GodUtil.autoCreate(UserStore.getState().apiKey, options)
      .then(data => {
        UserActions.setGodUser(data.id);
        UserActions.godAutoCreateUser(data.user);
        UserActions.fetchCurrentPage(false);
        history.push("/god");
        this.setState({ autoCreating: false });
      })
      .catch(GodActions.godFailed);
  }

  onFetchStats() {
    GodUtil.fetchStats(UserStore.getState().apiKey)
      .then(data => {
        this.setState({ stats: data.stats });
      })
      .catch(GodActions.godFailed);
  }

  onFetchRevenue() {
    GodUtil.fetchRevenue(UserStore.getState().apiKey)
      .then(data => {
        this.setState({ revenue: data.revenue });
      })
      .catch(GodActions.godFailed);
  }

  onFetchUpcomingEvents() {
    GodUtil.fetchUpcomingEvents(UserStore.getState().apiKey)
      .then(data => {
        this.setState({ upcomingEvents: data });
      })
      .catch(GodActions.godFailed);
  }

  onBecomePerson(person) {
    GodUtil.becomePerson(UserStore.getState().apiKey, person)
      .then(data => {
        console.log(
          `Congrats, God. You've become ${person}. Use your power wisely.`
        );
        console.log(data.token);
        console.log(`document.cookie='eventive-token=${data.token}'`);
      })
      .catch(GodActions.godFailed);
  }

  onGodFailed(e) {
    alert(`God failed: ${e.message}`);
    this.setState({ autoCreating: false });
  }
}

export default alt.createStore(GodStore, "GodStore");



// WEBPACK FOOTER //
// ./src/app/stores/GodStore.js